import React from "react";
import { Link } from "react-router-dom";

const Error404 = () => {
   return (
      <div className="authincation">
         <div className="container h-100">
            <div className="row justify-content-center h-100 align-items-center ">
               <div className="col-md-5">
                  <div className="form-input-content text-center error-page">
                     <h1 style={{fontSize:60}} className=" font-weight-bold">No Internet</h1>
                     <h4>
                        <i className="fa fa-exclamation-triangle text-warning" />{" "}
                        Please check your internet connections
                     </h4>
                    
                     <div>
                        <Link className="btn btn-primary mt-4" to="/">
                           Back to Home
                        </Link>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default Error404;
